
import { ChevronLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface NavHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  showHome?: boolean;
}

const NavHeader = ({ title, subtitle, backTo, showHome = false }: NavHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-start gap-2 text-left">
        {backTo && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(backTo)}
            className="mr-2"
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
        )}
        <div className="text-left">
          <h1 className="text-2xl font-medium text-left">{title}</h1>
          {subtitle && <p className="text-muted-foreground text-left">{subtitle}</p>}
        </div>
      </div>
      {showHome && (
        <Button variant="outline" size="icon" onClick={() => navigate("/")}>
          <Home className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default NavHeader;
